import * as Yup from 'yup';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';

export const getValidationSchema = (templateNames?: Set<string> | null, originalName?: string) =>
    Yup.object().shape({
        templateName: Yup.string()
            .required(getRequiredMessage('field'))
            .nullable()
            .test({
                name: 'unique-name',
                message: 'This name already exists',
                test: (value, _context) => {
                    if (value == null) return true;
                    if (value === originalName) return true;
                    return !templateNames?.has(value);
                },
            }),
    });
